module.exports = __webpack_public_path__ + "img/arrow_left.1c2897c1.svg";